/**
 * WheatFieldHero — photorealistic wheat-field animated backdrop.
 * The GIF is the sole motion source; no additional CSS/JS animations.
 * A subtle top-brighten and bottom-fade help text readability.
 */
export function WheatFieldHero() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <img
        src="/hero-field.gif"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        style={{ filter: "brightness(1.05) saturate(1.06)" }}
        loading="eager"
        decoding="async"
      />
      {/* Cinematic top light-lift and bottom fade to page */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-stone-50 pointer-events-none" />
    </div>
  );
}
